export class RealityCheckEvents {
    public static readonly SHOWED: symbol = Symbol('SHOWED');
    public static readonly QUIT_GAME_CLICKED: symbol = Symbol('QUIT_GAME_CLICKED');
    public static readonly GO_TO_ACCOUNT_CLICKED: symbol = Symbol('GO_TO_ACCOUNT_CLICKED');
}